import React, { useEffect, useState } from 'react';

// material-ui
import { Box, Button, Card, Grid, FormControlLabel, Checkbox, Switch, Tooltip, Icon, Avatar, Dialog, Badge, Tab, Tabs } from '@mui/material';

import { TCInput, TCSelect, TCSelectStyle } from 'components/TopCourtComponents/Input/TopCourtInput';
import { TCLabel, TCTitleLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';

import ReactQuill from 'react-quill';

import { color, orderTypeCategoryOptions } from 'constant/constant';
import { createClass, getClassDetail, getClassParticipant, loadBookingforClasses, updateClass } from 'services/classService';
import TCAccordion from 'components/TopCourtComponents/TCAccordion';
import moment from 'moment';
import { BookingScheduleList } from '../classes/schedule';

import { handleUpload } from 'helper/S3';
import { getParamsFromURL } from 'helper/Params';
import { validation } from 'helper/Form';
import { toastMessage } from 'components/Toast/Toast';
import ControlledNumericFormat from 'components/TopCourtComponents/Input/ControlledNumericFormat';
import { Info } from '@mui/icons-material';
import { getSportCourtTypes } from 'services/placeServices';
import { getCategories } from 'services/categoryServices';
import { createTournament, getApplicantVerification, getTournamentApplicant, getTournamentCategory, getTournamentDetail, getTournamentFormat, getTournamentLevel, updateRegistrationStatus, updateTournamentInfo } from 'services/tournamentServices';
import { useNavigate } from 'react-router';
import { IconCheck, IconHourglass, IconPencil, IconX } from '@tabler/icons';
import { updateVerificationStatus, updateVerificationPhoto } from 'services/dashboardServices';
import { getPlayers } from 'services/playerServices';
import AsyncSelect from 'react-select/async';
import ImageCropper from 'components/CropImage';
import TournamentParticipant from './tournamentParticipant';

import DeleteIcon from '@mui/icons-material/Delete';
import SetSchedule from './matchSchedule';
import TournamentCategoryMatch from './TournamentCategoryMatch';
import DropZoneComponent from 'components/DropzoneComponent';
import { getUrlCourtCode } from 'helper/Court';

const minimumTypeOptions = [
    { value: "purchase", label: "Total Amount" },
    { value: "session", label: "Total Session" }
]

const forfeitInformation = ""

function AddTournament({

}) {

    const navigate = useNavigate()

    var toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    ];

    var typeOptions = [
        { value: "event", label: "Event" },
        { value: "class", label: "Class" }
    ]

    const [tournamentFormat, setTournamentFormat] = useState([])
    const [tournamentCategory, setTournamentCategory] = useState([])
    const [tournamentLevel, setTournamentLevel] = useState([])
    const [participant, setParticipant] = useState([])
    const [bookingCategory, setBookingCategory] = useState([])
    const [addOnCategory, setAddOnCategory] = useState([])
    const [matchIndexTooltip, setMatchIndexTooltip] = useState(false)
    const [forceReload, setForceReload] = useState(Date.now())
    const [currentTab, setCurrentTab] = useState(0)

    const [form, setForm] = useState({
        name: "",
        orderType: { label: "Booking", value: 'booking' },
        scheduleInfo: [],
        categoriesList: [],
        categories: [],
        categoriesInfo: [],
        tournamentFormat: "pool",
        description: "",
        additionalInfo: false,
        additionalInfoTitle: "",
        tournamentFormatSetting: {
            numberPool: 2,
            winnersPerPool: 1
        },
        criteria: {
            type: '',
            courtCategory: [],
            addOnCategory: [],
            requirement: '',
            amount: '',
            startDate: '',
            excludeUser: []
        },
        hideUsername: false,
        multipleCategoryPerPlayer: false,
        forfeitWinningScore: 1,
        registrationDeadline: null,
        userInCharge: [],
        tournamentImages: []
    })

    const [joiForm, setJoiForm] = useState({
        name: null,
        registrationDeadline: null,
        hours: null,
        tournamentCategory: null,
        description: null,
        minimumPurchase: null,
        minimumSession: null,
        bookingStartDate: null
    })

    const [bookingList, setBookingList] = useState([])
    const [currentClass, setCurrentClass] = useState([])
    const [applicantExistCategory, setApplicantExistCategory] = useState([])
    const [loading, setLoading] = useState(false)
    const [reload, setReload] = useState(Date.now)

    useEffect(() => {
        loadSportCourtTypeId()
        loadAddOnCategory()
        loadTournamentCategoryandFormat()
    }, [])

    useEffect(() => {
        const filteredCategories = form.categories.filter(item => form.categoriesInfo.some(obj => obj.value === item));
        let isNotAdded = false
        for (let i = 0; i < form.categoriesInfo.length; i++) {
            if (!form.categoriesInfo[i].level || !form.categoriesInfo[i].totalPlayer) { isNotAdded = true }
        }
        setJoiForm({
            name: form.name ? null : "*",
            hours: form.scheduleInfo && form.scheduleInfo.length > 0 ? null : "*",
            registrationDeadline: form.registrationDeadline ? null : "*",
            tournamentCategory: filteredCategories && (filteredCategories.length > 0 && !isNotAdded) ? null : "*",
            description: removeTags(form.description) <= 1000 ? null : "*",
            minimumPurchase: form.type == "amount" ? !form.criteria.requirement ? "*" : null : null,
            minimumSession: form.type == "session" ? !form.criteria.requirement ? "*" : null : null,
            // numberOfPool: (form.tournamentFormat == "pool" && !form.tournamentFormatSetting.numberPool) ? "*" : null,
            bookingStartDate: ((form.criteria.courtCategory && form.criteria.courtCategory.length > 0) && !form.criteria.startDate) ? "*" : null
        })
    }, [form])

    const loadSportCourtTypeId = async () => {
        try {
            let { data, error } = await getSportCourtTypes({})
            if (error) { throw error }
            let mappedData = data.map(v => {
                return {
                    label: `${v.sportTypeId.name} ${v.courtTypeId.name}`,
                    value: `${v._id}`
                }
            })
            setBookingCategory(mappedData)
            console.log('here check sportCourtTypeId', data)
        } catch (error) {
            console.log(error)
        }
    }

    const loadAddOnCategory = async () => {
        try {
            let { data, error } = await getCategories({})
            if (error) { throw error }
            let mappedData = data.map(v => {
                return {
                    label: `${v.name}`,
                    value: `${v._id}`
                }
            })
            setAddOnCategory(mappedData)
            console.log('here check AddOnCategory', data)
        } catch (error) {
            console.log(error)
        }
    }

    const loadTournamentCategoryandFormat = async () => {
        let category = await getTournamentCategory()
        if (category.data) { setTournamentCategory(category.data) }
        let format = await getTournamentFormat()
        if (format.data) { setTournamentFormat(format.data) }
        let level = await getTournamentLevel()
        if (level.data) { setTournamentLevel(level.data) }
    }

    useEffect(() => {
        if (tournamentLevel.length > 0) { loadTournamentInfo() }
    }, [setBookingCategory, addOnCategory, tournamentLevel])

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
    }

    const removeTags = (str) => {
        if ((str === null) || (str === ''))
            return 0;
        else
            str = str.toString();
        let stringWithoutTags = str.replace(/<br>/g, ' ');
        let stringWithoutLineBreaks = stringWithoutTags.replace(/(<([^>]+)>)/ig, ''); // Replace line breaks with '\n'
        return stringWithoutLineBreaks.length;
    }

    const loadTournamentInfo = () => {
        // check Id
        let { params } = getParamsFromURL(window);
        if (params) {
            loadTournamentDetail(params)
            loadClassBooking(params)
        } else { loadClassBooking() }
    }

    const loadTournamentDetail = async (classId) => {
        let { data, error } = await getTournamentDetail({ id: classId })
        if (data) {
            let newCourtCategory = data.criteria?.courtCategory.map(v => {
                return bookingCategory.find(value => value.value.toString() === v._id.toString())
            })
            let hoursFlatMap = data.tournamentSession.flatMap(session => session.hours || []);
            hoursFlatMap = [...new Set(hoursFlatMap.map(h => h))]

            for (let i = 0; i < data.tournamentSession.length; i++) {
                let v = data.tournamentSession[i]
                checkCourtInfo({
                    date: v.date,
                    court: null,
                    hours: v.hours
                }, {
                    courtType: v.courtId.courtType,
                    hours: v.hours,
                    date: v.date,
                    _id: v.courtId._id,
                    orderSession: v.orderSessionId,
                    name: v.courtId.name
                })
            }

            setForm(prev => ({
                ...prev,
                ...data,
                tournamentFormat: data.format?.formatId,
                hours: hoursFlatMap,
                categories: data.categories.map(v => { return v.tournamentCategoryId.categoryId.toString() }),
                categoriesList: data.categories.map(v => {
                    return {
                        id: v.tournamentCategoryId._id,
                        value: v.tournamentCategoryId.categoryId,
                        name: v.tournamentCategoryId.name,
                        level: tournamentLevel.find(vi => vi._id.toString() == v.tournamentLevel._id.toString()),
                        customName: v.customName || 0,
                        totalPlayer: v.totalPlayer || 0,
                        disabled: false,
                        applicant: v.applicant || 0,
                        pending: v.pending || 0,
                        waitingList: v.waitingList || 0
                    }
                }),
                categoriesInfo: data.listCategoriesInfo.map(v => {
                    return {
                        catLevelId: Math.random(),
                        id: v.tournamentCategoryId._id,
                        value: v.tournamentCategoryId.categoryId,
                        edited: false,
                        name: v.tournamentCategoryId.name,
                        level: tournamentLevel.find(vi => vi._id.toString() == v.tournamentLevel._id.toString()),
                        customName: v.customName || 0,
                        totalPlayer: v.totalPlayer || 0,
                        disabled: false,
                        applicant: v.applicant || 0,
                        pending: v.pending || 0,
                        waitingList: v.waitingList || 0,
                        numberOfPool: v.numberOfPool || 0,
                        winnersPerPool: v.winnersPerPool || 0,
                        matchStart: v.matchStart || 0
                    }
                }),
                orderType: data.criteria ? orderTypeCategoryOptions.find(v => v.value === data.criteria.criteriaType) : form.orderType,
                criteria: data.criteria ? {
                    ...data.criteria,
                    type: orderTypeCategoryOptions.find(v => v.value === data.criteria.criteriaType),
                    requirement: minimumTypeOptions.find(v => v.value == data.criteria.requirement),
                    courtCategory: newCourtCategory,
                    startDate: moment(data.criteria.startDate).format('YYYY-MM-DD')
                } : {
                    type: '',
                    courtCategory: [],
                    addOnCategory: [],
                    requirement: '',
                    amount: '',
                    startDate: ''
                },
                registrationDeadline: moment(data.registrationDeadline).format('YYYY-MM-DD')
            }))
            setApplicantExistCategory(data.applicantExistCategory)
        }
    }

    const disabledForm = () => {
        if (joiForm.name) { return true }
        if (joiForm.hours) { return true }
        if (joiForm.registrationDeadline) { return true }
        if (joiForm.tournamentCategory) { return true }
        if (joiForm.description) { return true }
        if (joiForm.numberOfPool) { return true }
        if (form.categoriesInfo) { return form.categoriesInfo.some(v => !v.numberOfPool || !v.totalPlayer || !v.winnersPerPool) }
        return false
    }

    const loadClassBooking = async (params) => {
        try {
            setLoading(true)
            let { data, error } = await loadBookingforClasses(params || '', '')
            if (data) {
                let newBookings = []
                newBookings = groupSession(data.orders)
                setBookingList(newBookings)
                setCurrentClass(data.classOrder)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    const submitTournament = async () => {
        setLoading(true)
        let newForm = { ...form }
        newForm.tournamentImages = []
        if (form.tournamentImages) {
            for (let i = 0; i < form.tournamentImages.length; i++) {
                // check if class image is string
                if (typeof form.tournamentImages[i] !== 'string') {
                    let imageUrl = await handleUpload(form.tournamentImages[i])
                    newForm.tournamentImages.push(imageUrl[0])
                } else {
                    newForm.tournamentImages.push(form.tournamentImages[i])
                }
            }
        }
        let { data, error } = await createTournament(newForm)
        toastMessage(`Tournament created`, {
            toastId: "update-class",
            type: "success"
        })
        if (data) { window.location.replace(`/${getUrlCourtCode()}/match-tournament/tournament/edit/${data._id}`) }
        setLoading(false)
    }

    const updateTournament = async () => {
        setLoading(true)
        let newForm = { ...form }
        newForm.tournamentImages = []
        if (form.tournamentImages) {
            for (let i = 0; i < form.tournamentImages.length; i++) {
                // check if class image is string
                if (typeof form.tournamentImages[i] !== 'string') {
                    let imageUrl = await handleUpload(form.tournamentImages[i])
                    newForm.tournamentImages.push(imageUrl[0])
                } else {
                    newForm.tournamentImages.push(form.tournamentImages[i])
                }
            }
        }
        let { data, error } = await updateTournamentInfo(newForm)
        toastMessage(`Tournament Updated`, {
            toastId: "update-class",
            type: "success"
        })
        if (data) { window.location.replace(`/${getUrlCourtCode()}/match-tournament/tournament/edit/${data._id}`) }
        setLoading(false)
    }

    useEffect(() => { console.log(form) }, [form])

    const checkCourtInfo = (e, v) => {
        console.log('here e', e, v)
        let scheduleInfo = form.scheduleInfo
        if (!scheduleInfo || scheduleInfo.length == 0) {
            scheduleInfo.push({
                date: e.date,
                courts: [v._id],
                orderSession: [v.orderSession],
                courtsInfo: [{
                    name: v.name,
                    courtType: v.courtType,
                    hours: [...new Set(e.hours.map(h => h))]
                }]
            })
        } else {
            let similar = false
            for (let i = 0; i < scheduleInfo.length; i++) {
                if (scheduleInfo[i].date == e.date) {
                    if (scheduleInfo[i].courts.indexOf(v._id) < 0) {
                        scheduleInfo[i].courts.push(v._id)
                        scheduleInfo[i].orderSession.push(v.orderSession)
                        scheduleInfo[i].courtsInfo.push({
                            name: v.name,
                            courtType: v.courtType,
                            hours: [...new Set(e.hours.map(h => h))]
                        })
                    } else {
                        for (let j = 0; j < scheduleInfo[i].courts.length; j++) {
                            let courtsInfo = scheduleInfo[i].courts[j]
                            if (v._id == courtsInfo) {
                                scheduleInfo[i].courtsInfo[j].hours = [...new Set(e.hours.map(h => h))]
                            }
                        }
                    }
                    similar = true
                    break;
                }
            }
            if (!similar) {
                scheduleInfo.push({
                    date: e.date,
                    courts: [v._id],
                    orderSession: [v.orderSession],
                    courtsInfo: [{
                        name: v.name,
                        courtType: v.courtType,
                        hours: [...new Set(e.hours.map(h => h))]
                    }]
                })
            }
        }
        if (e.hours.length == 0) {
            let scheduleInfoData = null
            let newScheduleData = []
            for (let i = 0; i < scheduleInfo.length; i++) {
                let newCourtInfo = []
                let newCourts = []
                for (let j = 0; j < scheduleInfo[i].courtsInfo.length; j++) {
                    let courtInfo = scheduleInfo[i].courtsInfo[j]
                    if (courtInfo.hours && courtInfo.hours.length > 0) {
                        newCourts.push(scheduleInfo[i].courts[j])
                        newCourtInfo.push(courtInfo)
                    }
                }
                scheduleInfo[i].courts = newCourts
                scheduleInfo[i].courtsInfo = newCourtInfo.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                if (newCourts.length > 0) {
                    newScheduleData.push(scheduleInfo[i])
                }
            }
            scheduleInfoData = newScheduleData[0]
            if (scheduleInfoData) {
                onChange({
                    scheduleInfo: newScheduleData
                })
                return;
            }
        }
        let newScheduleInfo = []
        for (let i = 0; i < scheduleInfo.length; i++) {
            if (scheduleInfo[i].courts.length > 0) {
                newScheduleInfo.push(scheduleInfo[i])
            }
        }

        if (moment(form?.registrationDeadline).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            onChange({
                scheduleInfo: newScheduleInfo
            })
        } else {
            onChange({
                scheduleInfo: newScheduleInfo,
                registrationDeadline: ''
            })
        }
        setReload(Date.now)
    }

    const loadUserOption = async (input) => {
        if (input.length < 1) {
            return
        }
        try {
            let { data, error } = await getPlayers({
                // name: input,
                namePhoneNumber: input
            });
            if (error) throw error
            if (data) {
                if (data.length <= 0) return
                return data.map(value => {
                    return {
                        label: value.name,
                        value: value._id
                    }
                })
            }
        } catch (error) {
            console.log(error.message || error)
            return ([])
        }
    }

    const deleteTournamentImages = (index) => {
        let currImages = form.tournamentImages
        currImages.splice(index, 1);
        onChange({ tournamentImages: currImages })
    }

    const menu = [
        { title: "Participant" }, { title: "Schedule" }, { title: "Category" }, { title: "Bracket" }
    ]

    return (
        <>
            <Grid container spacing={2}>
                <Grid item container xs={12} md={6} lg={6}>
                    <Card sx={{ p: 2, pl: 0, pr: 0 }}>
                        <Box sx={{
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <>
                                <Grid container p={2} pt={0} rowSpacing={1} style={{ overflow: 'auto' }}>
                                    <Grid item xs={12}>
                                        <TCInput showAlert={joiForm.name}
                                            // disabled={form._id}
                                            label={"Tournament Name"} value={form.name} onChange={(e) => {
                                                if (e.currentTarget.value.length >= 50) { return; }
                                                onChange({ name: e.currentTarget.value.trimStart() })
                                            }} />
                                    </Grid>
                                    <Grid item container xs={12} mt={1} sx={{
                                        border: '1px solid #85858533',
                                        borderRadius: 2
                                    }}>
                                        <Grid item container p={1} pt={0}>
                                            {bookingList.length > 0 ?
                                                <Grid item container>
                                                    <Grid item>
                                                        <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Select Tournament Session Time</TCLabel>
                                                    </Grid>
                                                    <Grid item>
                                                        <TCLabel style={{ color: 'red' }}>{joiForm.hours}</TCLabel>
                                                    </Grid>
                                                    <Grid xs={12}>
                                                        {
                                                            bookingList.map(value => {
                                                                return (
                                                                    <Card item xs={12} mb={1}>
                                                                        <TCAccordion title={
                                                                            <TCLabel>
                                                                                <div>
                                                                                    {moment(value.date).format("DD/MM/YYYY")}
                                                                                    <div>{value.eventName}</div>
                                                                                </div>
                                                                            </TCLabel>
                                                                        }>
                                                                            {
                                                                                value.courts.map(v => {
                                                                                    return (
                                                                                        <BookingScheduleList data={{
                                                                                            ...v, date: value.date,
                                                                                            selected: form.scheduleInfo,
                                                                                            selectedHours: form.hours
                                                                                        }}
                                                                                            reload={reload}
                                                                                            // court={form.court} 
                                                                                            // date={form.date} 
                                                                                            allowMultipleCourt={true}
                                                                                            allowMultiple={true}
                                                                                            disableSelectionClass={{
                                                                                                currentClass: currentClass,
                                                                                                court: v._id,
                                                                                                date: value.date
                                                                                            }}
                                                                                            onChangeSchedule={(e) => {
                                                                                                checkCourtInfo(e, v)
                                                                                            }} />
                                                                                    )
                                                                                })
                                                                            }
                                                                        </TCAccordion>
                                                                    </Card>
                                                                )
                                                            })}
                                                    </Grid>
                                                </Grid>
                                                :
                                                <Grid item>
                                                    <TCLabel >No Available Court</TCLabel>
                                                </Grid>
                                            }

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid item xs={4.2}>
                                            <TCInput value={form.registrationDeadline}
                                                showAlert={joiForm.registrationDeadline}
                                                style={{ weekStart: 1 }}
                                                label="Registration Deadline" type="date"
                                                onChange={(e) => {
                                                    onChange({ registrationDeadline: e.currentTarget.value })
                                                }}
                                                inputProps={{
                                                    InputProps: {
                                                        inputProps: { min: moment().format("YYYY-MM-DD"), max: form.scheduleInfo.length > 0 ? moment(form.scheduleInfo.sort((a, b) => a.date.localeCompare(b.date))[0].date).add(-1, 'days').format("YYYY-MM-DD") : moment().format("YYYY-MM-DD") }
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container mt={1}>
                                        <Grid xs={12} mt={.5} p={1} sx={{
                                            border: '1px solid #85858533',
                                            borderRadius: 2
                                        }}>
                                            <Grid xs={12}><TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Tournament Format</TCLabel></Grid>
                                            <Grid container gap={2}>
                                                {tournamentFormat.map(v => {
                                                    return (
                                                        <Grid item>
                                                            <FormControlLabel control={<Checkbox
                                                                checked={v.value == form.tournamentFormat} onChange={() => {
                                                                    onChange({ tournamentFormat: v.value })
                                                                }} />} label={<TCLabel>{v.label}</TCLabel>} />
                                                        </Grid>
                                                    )
                                                })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container p={1} pb={2} pt={0.5} mt={0.5} sx={{
                                            border: '1px solid #85858533',
                                            borderRadius: 2
                                        }}>
                                            <Grid container xs={12}>
                                                <Grid item>
                                                    <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Tournament Category</TCLabel>
                                                </Grid>
                                                <Grid item>
                                                    <TCLabel style={{ color: 'red' }}>{joiForm.tournamentCategory}</TCLabel>
                                                </Grid>
                                            </Grid>
                                            {tournamentCategory.map(v => {
                                                return (
                                                    <Grid item xs={12} sm={12} md={12} lg={6}>
                                                        <TournamentCategory form={form}
                                                            disabled={applicantExistCategory.some(x => x == v.categoryId)} id={v._id} title={v.label} value={v.value}
                                                            applicantExistCategory={applicantExistCategory}
                                                            tournamentLevel={tournamentLevel}
                                                            data={v}
                                                            setCategories={(e) => {
                                                                console.log(e)
                                                                let newArray = [...form.categories]
                                                                if (newArray.indexOf(e) >= 0) {
                                                                    console.log('here listInfo', newArray.indexOf(e))
                                                                    newArray = newArray.filter(v => v != e)
                                                                    let listInfo = [...form.categoriesInfo]
                                                                    listInfo = listInfo.filter(vi => vi.value != e)
                                                                    console.log('here listInfo', listInfo, [...newArray])
                                                                    onChange({
                                                                        categoriesInfo: listInfo,
                                                                        categories: [...newArray]
                                                                    })
                                                                    return;
                                                                } else {
                                                                    newArray.push(e)
                                                                }
                                                                onChange({
                                                                    categories: [...newArray]
                                                                })
                                                            }}
                                                            setCategoriesInfo={(e) => {
                                                                let listInfo = [...form.categoriesInfo]
                                                                let changesNumberPool = false
                                                                // let index = listInfo.findIndex(vi => vi.value == v.value)
                                                                let index = listInfo.findIndex(vi => vi.catLevelId == e.catLevelId)
                                                                if (index >= 0) {
                                                                    if (listInfo[index].totalPlayer != e.totalPlayer) { changesNumberPool = true }
                                                                    console.log('here e', e)
                                                                    if (e.level.levelId != "others") {
                                                                        e.customName = ''
                                                                    }
                                                                    listInfo[index] = { ...listInfo[index], ...e }
                                                                }
                                                                else { listInfo.push(e) }
                                                                let catArr = listInfo.map(v => v.value)
                                                                const newListCategories = [...new Set(catArr)];
                                                                onChange({
                                                                    categoriesInfo: listInfo, categories: newListCategories, tournamentFormatSetting: {
                                                                        ...form.tournamentFormatSetting,
                                                                        numberPool: changesNumberPool ? '' : form.tournamentFormatSetting.numberPool
                                                                    }
                                                                })
                                                            }}
                                                            removeLevel={(e) => {
                                                                let { id, value, catLevelId } = e
                                                                let listInfo = [...form.categoriesInfo]
                                                                listInfo = listInfo.filter(v => !(v.catLevelId == catLevelId))
                                                                let catArr = listInfo.map(v => v.value)
                                                                const newListCategories = [...new Set(catArr)];
                                                                onChange({ categoriesInfo: listInfo, categories: newListCategories })
                                                            }}
                                                            // currCategoriesInfo={form.categoriesInfo ? form.categoriesInfo.find(vi => vi.value.toString() == v.value.toString()) : null}
                                                            currCategoriesInfo={form.categoriesInfo ? form.categoriesInfo.filter(vi => vi.value.toString() == v.value.toString()) : null}
                                                        />
                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel control={<Checkbox
                                            checked={form.hideUsername} onChange={() => {
                                                onChange({
                                                    hideUsername: !form.hideUsername
                                                })
                                            }} />} label={<TCLabel>Hide participant name</TCLabel>} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Multiple Category Per Player</TCLabel>
                                        <Switch
                                            sx={{ marginLeft: -1 }}
                                            checked={form.multipleCategoryPerPlayer}
                                            onChange={() => onChange({ multipleCategoryPerPlayer: !form.multipleCategoryPerPlayer })}
                                        />
                                    </Grid>
                                    <Grid mt={1}>
                                        <div style={{ display: 'flex' }}>
                                            <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Forfeit Winning Score</TCLabel>
                                            <Tooltip style={{
                                                marginLeft: 4,
                                            }} title={<div style={{
                                                fontSize: 10,
                                                textAlign: 'left'
                                            }}>
                                                <div style={{ fontWeight: 'bold' }}>Skill level</div>
                                                <div style={{ marginTop: -2, lineHeight: 1 }}>Based on players skill levels for fair and balanced games</div>
                                                <div style={{ marginTop: -2, lineHeight: 1 }}>{forfeitInformation}</div>

                                                <div style={{ fontWeight: 'bold', marginTop: 4 }}>Americano</div>
                                                <div style={{ marginTop: -2, lineHeight: 1 }}>All players play with everyone once. Fun and social</div>

                                                <div style={{ fontWeight: 'bold', marginTop: 4 }}>Mix Americano</div>
                                                <div style={{ marginTop: -2, lineHeight: 1, marginBottom: 4 }}>A woman and a man in each team, equal number of women and men required</div>
                                            </div>}
                                                open={matchIndexTooltip}
                                                PopperProps={{
                                                    modifiers: [
                                                        {
                                                            name: 'offset',
                                                            options: {
                                                                offset: [0, 0], // [horizontal offset, vertical offset]
                                                            },
                                                        },
                                                    ],
                                                    sx: {
                                                        '&[data-popper-placement*="bottom"] .MuiTooltip-tooltip': {
                                                            // marginTop: '2px', // override the default margin
                                                            marginTop: '0px !important'
                                                        },
                                                        '.MuiTooltip-tooltip': {
                                                            background: 'white',
                                                            border: '0.1px solid grey',
                                                            boxShadow: '8px 8px 5px -5px rgba(0,0,0,0.26)',
                                                            color: '#025597'
                                                        },
                                                        '& .MuiTooltip-arrow::before': {
                                                            border: '0.1px solid grey',
                                                            backgroundColor: 'white',
                                                            color: '#FFFFFF'
                                                        }
                                                    }
                                                }}
                                            >
                                                <div style={{
                                                    fontSize: 16,
                                                    marginLeft: 4
                                                }}>
                                                    <Info fontSize='10' onClick={(e) => {
                                                        e.stopPropagation()
                                                        setMatchIndexTooltip(!matchIndexTooltip);
                                                    }}
                                                        sx={{ color: '#7b809a' }}>information</Info>
                                                </div>
                                            </Tooltip>
                                        </div>
                                        <TCInput type="number" value={form.forfeitWinningScore}
                                            disabled={false}
                                            buttonPosition="outside" // or 'inside'
                                            onChange={(e) => {
                                                if (!validation.isNumber(e.currentTarget.value)) { return; }
                                                // max 5
                                                if (Number(e.currentTarget.value) < 1) { return; }
                                                if (Number(e.currentTarget.value) > 5) { return; }
                                                onChange({ forfeitWinningScore: e.currentTarget.value })
                                            }} />
                                    </Grid>
                                    <Grid container xs={12} mt={1}>
                                        <Grid container xs={12} sx={{
                                            border: '1px solid #85858533',
                                            borderRadius: 2,
                                            padding: 1
                                        }}>
                                            <Grid xs={12}><TCLabel style={{
                                                color: 'rgb(133, 133, 133)'
                                            }}>Criteria</TCLabel></Grid>
                                            <Grid item container spacing={1} xs={12} md={12} sx={{ p: 1, pl: 0, pr: 0 }}>
                                                <Grid item xs={12} md={4}>
                                                    <TCSelect
                                                        label={"Type"}
                                                        value={form.orderType}
                                                        onChange={(e) => {
                                                            if (e.value != "booking" || e.value != "add_on") {
                                                                onChange({
                                                                    orderType: e,
                                                                })
                                                            }
                                                            onChange({
                                                                orderType: e
                                                            })
                                                        }}
                                                        options={orderTypeCategoryOptions}
                                                    />
                                                </Grid>
                                                <Grid container item xs={12} md={8}>
                                                    {
                                                        form.orderType.value == "booking" &&
                                                        <Grid xs={12} md={12} sx={{ p: 0 }}>
                                                            <TCSelect
                                                                label={"Category"}
                                                                isMulti={true}
                                                                value={form.criteria.courtCategory}
                                                                onChange={(e) => {
                                                                    console.log('here e', e)
                                                                    let otherParams = {
                                                                        ...form.criteria
                                                                    }
                                                                    if (e.length == 0) {
                                                                        otherParams = {
                                                                            requirement: null,
                                                                            amount: null,
                                                                            startDate: ""
                                                                        }
                                                                    }
                                                                    onChange({
                                                                        criteria: {
                                                                            ...otherParams,
                                                                            courtCategory: e
                                                                        }
                                                                    })
                                                                }}
                                                                options={bookingCategory}
                                                            />
                                                        </Grid>
                                                    }
                                                    {
                                                        form.orderType.value == "add_on" &&
                                                        <Grid xs={12} md={12} sx={{ p: 0 }}>
                                                            <TCSelect
                                                                label={"Add On Category"}
                                                                isMulti={true}
                                                                value={form.criteria.addOnCategory}
                                                                onChange={(e) => {
                                                                    onChange({
                                                                        criteria: {
                                                                            ...form.criteria,
                                                                            addOnCategory: e
                                                                        }
                                                                    })
                                                                }}
                                                                options={addOnCategory}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                                <Grid item xs={12} md={4} sx={{ p: 0 }}>
                                                    <TCSelect
                                                        label={"Requirement"}
                                                        isClearable={true}
                                                        disabled={!form.criteria.courtCategory || form.criteria.courtCategory.length == 0}
                                                        value={form.criteria.requirement}
                                                        onChange={(e) => {
                                                            onChange({
                                                                criteria: {
                                                                    ...form.criteria,
                                                                    requirement: e
                                                                }
                                                            })
                                                        }}
                                                        options={(form.orderType.value == 'booking' || form.orderType.value == 'add_on') ? minimumTypeOptions : [{ value: "purchase", label: "Total Amount" },]}
                                                    />
                                                </Grid>
                                                {
                                                    (form.criteria.requirement && form.criteria.requirement.value == "purchase") &&
                                                    <Grid item xs={12} md={8}>
                                                        <Grid item>
                                                            <Grid item container spacing={1}>
                                                                <Grid item>
                                                                    <TCLabel style={{
                                                                        color: 'rgb(133, 133, 133)'
                                                                    }}>Minimum</TCLabel>
                                                                </Grid>
                                                                <Grid item>
                                                                    <TCLabel style={{ color: 'red' }}>{joiForm.minimumPurchase}</TCLabel>
                                                                </Grid>
                                                            </Grid>
                                                            <ControlledNumericFormat
                                                                value={form.criteria.amount}
                                                                onValueChange={(values) => {
                                                                    const { formattedValue, value, floatValue } = values;
                                                                    // do something with floatValue
                                                                    // onChange({ bundlePrice: value.replace(/^0+/, '') })
                                                                    let v = value.replace(/[^0-9]/g, "")
                                                                    if (!v) {
                                                                        onChange({
                                                                            criteria: {
                                                                                ...form.criteria,
                                                                                amount: v
                                                                            }
                                                                        })
                                                                        return
                                                                    }
                                                                    if (Number(v) <= 0) { v = "" }
                                                                    onChange({
                                                                        criteria: {
                                                                            ...form.criteria,
                                                                            amount: v
                                                                        }
                                                                    })
                                                                }}
                                                                // disabled={form._id}
                                                                decimalScale={0}
                                                                allowLeadingZeros={false}
                                                                allowedDecimalSeparators={false}
                                                                allowNegative={false}
                                                                thousandSeparator
                                                                customInput={TCInput} />
                                                        </Grid>
                                                    </Grid>
                                                }
                                                {
                                                    (form.criteria.requirement && form.criteria.requirement.value == "session") &&
                                                    <Grid item xs={12} md={8}>
                                                        <TCInput value={form.criteria.amount} onChange={(e) => {
                                                            let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                                                            if (!value) {
                                                                onChange({
                                                                    criteria: {
                                                                        ...form.criteria,
                                                                        amount: value
                                                                    }
                                                                })
                                                                return
                                                            }
                                                            if (Number(value) <= 0) { value = "" }
                                                            onChange({
                                                                criteria: {
                                                                    ...form.criteria,
                                                                    amount: value
                                                                }
                                                            })
                                                        }} label={<TCLabel>Minimum<span style={{ color: '#f44336' }}>{joiForm.minimumSessions}</span></TCLabel>} />
                                                    </Grid>
                                                }
                                                <Grid item container xs={12} md={12} spacing={1}>
                                                    <Grid item xs={12} md={4}>
                                                        <TCInput value={form.criteria.startDate}
                                                            style={{ weekStart: 1 }}
                                                            disabled={!form.criteria.courtCategory || form.criteria.courtCategory.length == 0}
                                                            showAlert={joiForm.bookingStartDate}
                                                            label="Booking Start Date" type="date"
                                                            onChange={(e) => {
                                                                // onChange({})
                                                                onChange({
                                                                    criteria: {
                                                                        ...form.criteria,
                                                                        startDate: e.currentTarget.value
                                                                    }
                                                                })
                                                            }}
                                                            inputProps={{
                                                                InputProps: {
                                                                    inputProps: { max: moment(new Date()).format("YYYY-MM-DD") }
                                                                }
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={8}>
                                                        <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Bypass User</TCLabel>
                                                        <AsyncSelect
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                ...TCSelectStyle
                                                            }}
                                                            placeholder={'Select User...'}
                                                            isClearable
                                                            async
                                                            defaultOptions
                                                            loadOptions={loadUserOption}
                                                            isMulti={true}
                                                            value={form.criteria.excludeUser} onChange={(e) => {
                                                                onChange({
                                                                    criteria: {
                                                                        ...form.criteria,
                                                                        excludeUser: e
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TCLabel>User</TCLabel>
                                        <AsyncSelect
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                ...TCSelectStyle
                                            }}
                                            placeholder={'Select User'}
                                            isClearable
                                            async
                                            defaultOptions
                                            loadOptions={loadUserOption}
                                            isMulti={true}
                                            value={form.userInCharge} onChange={(e) => { onChange({ userInCharge: e }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TCLabel style={{
                                            color: 'rgb(133, 133, 133)'
                                        }}>Additional Info Field (0/1000)</TCLabel>
                                        <Grid container alignItems={"center"} mt={form.additionalInfo ? 0.5 : 0}>
                                            <Grid item mt={form.additionalInfo ? 2 : 0}>
                                                <Switch
                                                    sx={{ marginLeft: -1 }}
                                                    checked={form.additionalInfo}
                                                    onChange={() => onChange({ additionalInfo: !form.additionalInfo })}
                                                />
                                            </Grid>
                                            <Grid>
                                                {
                                                    form.additionalInfo &&
                                                    <TCInput label={"Title Field"}
                                                        value={form.additionalInfoTitle}
                                                        onChange={(e) => onChange({ additionalInfoTitle: e.currentTarget.value })}
                                                    />
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TCLabel style={{
                                            color: 'rgb(133, 133, 133)'
                                        }}>Active</TCLabel>
                                        <Switch
                                            sx={{ marginLeft: -1 }}
                                            checked={form.isActive}
                                            onChange={() => onChange({ isActive: !form.isActive })}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TCLabel style={{
                                            color: 'rgb(133, 133, 133)'
                                        }}>Description</TCLabel>
                                        <ReactQuill theme="snow" value={form.description}
                                            modules={{ toolbar: toolbarOptions }}
                                            onChange={(e) => {
                                                if (removeTags(e).length >= 1000) { onChange({ description: form.description }); return; }
                                                onChange({ description: e })
                                            }}
                                        />
                                        <Grid sx={{
                                            textAlign: 'right'
                                        }}>
                                            {
                                                joiForm.description ?
                                                    <TCLabel style={{ fontSize: 10, color: 'red' }}>{`${removeTags(form.description)}/1000`}</TCLabel>
                                                    :
                                                    <TCLabel style={{ fontSize: 10, color: 'black' }}>{`${removeTags(form.description)}/1000`}</TCLabel>
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TCLabel style={{
                                            color: 'rgb(133, 133, 133)'
                                        }}>Upload Picture</TCLabel>
                                        <DropZoneComponent
                                            className="drop-zone"
                                            uploadName={"tournamentImages"}
                                            file={form.tournamentImages}
                                            isMultiple={false}
                                            onDrop={(files, event) => {
                                                if (files.length >= 4) { return; }
                                                let currImages = form.tournamentImages ? form.tournamentImages : []
                                                for (let i = 0; i < files.length; i++) {
                                                    currImages = currImages.concat(files[i])
                                                }
                                                onChange({ tournamentImages: currImages })
                                            }}
                                        >
                                            <div className='dropzone mb-0' style={{
                                                textAlign: 'center',
                                                minHeight: '150px'
                                            }}>
                                                <div style={{ padding: 10, alignItems: 'center' }}>
                                                    <label
                                                        htmlFor={"classImage"}
                                                        style={{ cursor: 'pointer' }}
                                                        className='dropzone-child mb-0'>
                                                        <i className='fa fa-upload mr-1' />
                                                        Upload Class Image
                                                    </label>
                                                    {/* <div style={{marginTop: 10}}></div>
                                        <label>
                                            Use your professional photo
                                        </label> */}
                                                    <div style={{ overflowX: 'auto' }}>
                                                        {
                                                            (form.tournamentImages && form.tournamentImages.length > 0) &&
                                                            <div style={{ textAlign: 'left' }}>
                                                                Uploaded file :
                                                                {
                                                                    form.tournamentImages.map((value, index) => {
                                                                        return (
                                                                            <div key={`${value.name}${index}`} className='d-flex mb-1' style={{ textAlign: 'left' }}>
                                                                                <img src={(!value.name && value.includes("https")) ? value : URL.createObjectURL(value)} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain' }}
                                                                                    onClick={() => {
                                                                                    }} alt=''
                                                                                />
                                                                                <label className='mt-1 mb-0 ml-1' style={{ alignItems: 'flex-end' }}>
                                                                                    {value.name}
                                                                                    <span style={{ marginLeft: 5, color: 'gray', cursor: 'pointer' }} onClick={() => {
                                                                                        deleteTournamentImages(index)
                                                                                    }}>X</span>
                                                                                </label>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </DropZoneComponent>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} p={2} textAlign={"right"}>
                                    <Button variant='contained' color={"primary"}
                                        disabled={disabledForm() || loading}
                                        onClick={() => {
                                            if (form._id) {
                                                updateTournament()
                                            } else {
                                                submitTournament()
                                            }
                                        }}>{
                                            form._id ? "Update" : "Create"
                                        }</Button>
                                </Grid>
                            </>
                        </Box>
                    </Card>
                </Grid>
                <Grid item container xs={12} md={6} lg={6}>
                    <Card sx={{ p: 2, pl: 0, pr: 0, width: '100%' }}>
                        <Box sx={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '100vh'
                        }}>
                            <>
                                <Grid container style={{ overflow: 'auto', marginTop: -16 }}>
                                    <Tabs
                                        value={currentTab}
                                        orientation="horizontal"
                                        variant="scrollable"
                                        onChange={(e, newValue) => setCurrentTab(newValue)}
                                    // sx={{ borderRight: 1, borderColor: "divider" }}
                                    >
                                        {
                                            menu.map((v, key) => {
                                                return (<Tab
                                                    key={key}
                                                    label={<TCLabel style={{ fontSize: 13 }}>{v.title}</TCLabel>}
                                                />)
                                            })
                                        }
                                    </Tabs>
                                    {
                                        ((form._id && form.categoriesList) && currentTab == 0) &&
                                        <TournamentParticipant tournamentInfo={form} tabList={
                                            form.categoriesList.map((v, idx) => {
                                                return {
                                                    label: v.name,
                                                    value: v.id,
                                                    data: v,
                                                    key: idx
                                                }
                                            })
                                        } tournamentId={form._id} additionalInfoTitle={form.additionalInfoTitle} reloadTournament={() => { loadTournamentInfo() }} />
                                    }
                                    {
                                        (form._id && currentTab == 1) &&
                                        <SetSchedule tournamentId={form._id} categoriesOptions={
                                            form.categoriesList.map((v, idx) => {
                                                return {
                                                    label: `${v.name} ${v.customName ? `(${v.customName})` : v.level ? `(${v.level.label})` : ''}`,
                                                    value: v.id,
                                                    data: v,
                                                    key: idx
                                                }
                                            }).sort((a, b) => a.label.localeCompare(b.label))
                                        } />
                                    }
                                    {
                                        (form._id && (currentTab == 2 || currentTab == 3)) &&
                                        <TournamentCategoryMatch tournamentId={form._id} categoriesOptions={
                                            form.categoriesList.map((v, idx) => {
                                                return {
                                                    label: `${v.name} ${v.level ? `(${v.level.label})` : ''}`,
                                                    value: v.id,
                                                    data: v,
                                                    key: idx
                                                }
                                            }).sort((a, b) => a.label.localeCompare(b.label))
                                        } type={currentTab == 2 ? "pool" : "bracket"} />
                                    }
                                </Grid>
                            </>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}

const groupSession = (
    userSessions
) => {
    let newOrder = []
    for (let i = 0; i < userSessions.length; i++) {
        if (newOrder.length == 0) {
            newOrder.push({
                date: userSessions[i].date,
                courts: [{
                    orderSession: userSessions[i]._id,
                    ...userSessions[i].court,
                    hours: [...userSessions[i].hours]
                }],
            })
        } else {
            let similiarDate = false
            for (let j = 0; j < newOrder.length; j++) {
                if (newOrder[j].date === userSessions[i].date) {
                    similiarDate = true
                    let courts = newOrder[j].courts
                    let similiarCourts = false
                    for (let k = 0; k < courts.length; k++) {
                        if (courts[k]._id.toString() == userSessions[i].court._id.toString()) {
                            courts[k].hours = courts[k].hours.concat(userSessions[i].hours)
                            courts[k].hours = bubbleSort(courts[k].hours)
                            similiarCourts = true
                        }
                    }
                    if (!similiarCourts) {
                        newOrder[j].courts.push({
                            orderSession: userSessions[i]._id,
                            ...userSessions[i].court,
                            hours: [...userSessions[i].hours]
                        })
                    }
                }
            }
            if (!similiarDate) {
                newOrder.push({
                    date: userSessions[i].date,
                    courts: [{
                        orderSession: userSessions[i]._id,
                        ...userSessions[i].court,
                        hours: [...userSessions[i].hours]
                    }],
                })
            }
        }
        // sort date
    }
    newOrder.sort((a, b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0))
    return newOrder
}

function bubbleSort(arr) {
    var i, j;
    var len = arr.length;
    var isSwapped = false;
    for (i = 0; i < len; i++) {
        isSwapped = false;
        for (j = 0; j < (len - i - 1); j++) {
            if (arr[j] > arr[j + 1]) {
                var temp = arr[j]
                arr[j] = arr[j + 1];
                arr[j + 1] = temp;
                isSwapped = true;
            }
        }
        if (!isSwapped) {
            break;
        }
    }
    return arr
}

function TournamentCategory({
    form, setCategories, id, disabled, tournamentLevel,
    title, value, setCategoriesInfo, currCategoriesInfo, removeLevel,
    applicantExistCategory
}) {

    let categoriesLevel = currCategoriesInfo.map(v => v.level._id.toString())
    const options = tournamentLevel.filter(vi => vi.levelId == 'others' || !categoriesLevel.some(v => v === vi._id.toString()))
    const isSelected = form.categories.indexOf(value) >= 0

    const [currForm, setCurrForm] = useState({
        _id: Date.now(),
        id,
        value,
        edited: false,
        level: null,
        customName: '',
        totalPlayer: 0
    })

    const [otherLevels, setOtherLevels] = useState([])

    useEffect(() => {
        console.log("here others levels", otherLevels)
    }, [otherLevels])

    useEffect(() => {
        if (currCategoriesInfo) {
            let newData = []
            for (let i = 0; i < currCategoriesInfo.length; i++) {
                let exist = newData.findIndex(vi => vi.catLevelId == currCategoriesInfo[i].catLevelId)
                if (exist >= 0) {
                    newData[exist] = {
                        edited: true,
                        catLevelId: currCategoriesInfo[i].catLevelId ? currCategoriesInfo[i].catLevelId : Date.now(),
                        ...currCategoriesInfo[i],
                        customName: currCategoriesInfo[i].customName || ''
                    }
                } else {
                    newData.push({
                        edited: true,
                        catLevelId: currCategoriesInfo[i].catLevelId ? currCategoriesInfo[i].catLevelId : Date.now(),
                        ...currCategoriesInfo[i],
                        customName: currCategoriesInfo[i].customName || ''
                    })
                }
            }
            setOtherLevels(newData)
        }
    }, [currCategoriesInfo])

    const AddLevel = () => {
        // filter available tournament level
        let otherLevel = [...otherLevels]
        let data = {
            catLevelId: Math.random(),
            id,
            value,
            edited: false,
            level: options[0],
            customName: '',
            totalPlayer: 0
        }
        otherLevel.push(data)
        setOtherLevels([...otherLevel])
        setCategoriesInfo(data)
    }

    const deleteLevel = (catLevelId) => {
        let otherLevel = [...otherLevels]
        removeLevel({
            value,
            id,
            catLevelId: catLevelId
        })
        otherLevel = otherLevel.filter(v => !(v.catLevelId == catLevelId))
        otherLevel = otherLevel.map(v => {
            return {
                ...v,
                edited: false
            }
        })
        console.log('here deleteLevel', otherLevel)
        setOtherLevels([...otherLevel])
    }

    return (
        <>
            <Grid>
                <FormControlLabel control={<Checkbox
                    checked={isSelected} disabled={disabled} onChange={() => {
                        setCategories(value)
                        if (!isSelected) {
                            AddLevel()
                        } else {
                            setOtherLevels([])
                        }
                    }} />} label={<TCLabel>{title}
                        {<button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                AddLevel()
                            }}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '13px',
                                height: '13px',
                                borderRadius: '50%',
                                backgroundColor: color.blueIndoor_2,
                                color: '#fff',
                                fontSize: '11px',
                                border: 'none',
                                marginLeft: '4px',
                                cursor: 'pointer',
                            }}
                        >+</button>}
                    </TCLabel>} />
                <div style={{ marginTop: '-4px' }}></div>
                {
                    otherLevels.map((v, idx) => {
                        console.log('here check otherLevels v', v)
                        return <TournamentOtherLevel v={v} form={{
                            ...form,
                            disabled: form.disabled || v.matchStart > 0
                        }} value={value}
                            disabled={applicantExistCategory.some(x => x == `${v.value}-${v.level.levelId}${v.customName || ''}`)}
                            options={options}
                            setCategoriesInfo={setCategoriesInfo}
                            position={(20 + (40 * idx))}
                            deleteLevel={(e) => deleteLevel(v.catLevelId)}
                        />
                    })
                }
            </Grid>
        </>
    )
}

function TournamentOtherLevel({
    v, form, disabled, options, value, setCategoriesInfo, position,
    deleteLevel
}) {


    const [joiForm, setJoiForm] = useState({
        level: null,
        totalPlayer: null,
        numberOfPool: null,
        winnersPerPool: null,
        customName: null
    })

    const [currForm, setCurrForm] = useState({
        ...v,
        winnersPerPool: 1,
        edited: false
    })

    useEffect(() => {
        setJoiForm({
            level: !currForm.level ? '*' : null,
            totalPlayer: !currForm.totalPlayer ? '*' : null,
            numberOfPool: (!currForm.numberOfPool && form.tournamentFormat == "pool") ? '*' : null,
            winnersPerPool: (!currForm.winnersPerPool && form.tournamentFormat == "pool") ? '*' : null,
            customName: (currForm.level && currForm.level.value == "custom") ? !currForm.customName ? '*' : null : null
        })
    }, [currForm])

    useEffect(() => {
        if (v && !v.edited) {
            setCurrForm(prev => ({
                ...prev,
                edited: true,
                ...v
            }))
        }
    }, [v])

    const onChange = (e) => {
        setCurrForm(prev => ({
            ...prev,
            edited: true,
            ...e,
        }))
    }

    useEffect(() => {
        if (currForm.edited) { setCategoriesInfo(currForm) }
    }, [currForm])

    return (
        <div style={{
            display: 'flex', marginTop: 11, marginRight: 8
        }}>
            <button
                type="button"
                onClick={(e) => {
                    if (!disabled) {
                        e.stopPropagation()
                        e.preventDefault()
                        deleteLevel()
                    }
                }}
                style={{
                    display: 'inline-flex',
                    position: 'absolute',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '13px',
                    height: '13px',
                    borderRadius: '50%',
                    backgroundColor: disabled ? color.grey : color.red,
                    color: '#fff',
                    fontSize: '11px',
                    border: 'none',
                    marginLeft: '-4px',
                    marginTop: '-8px',
                    cursor: 'pointer',
                }}
            ><DeleteIcon sx={{ fontSize: 10, color: 'white' }} /></button>
            <div className="line-line-container" style={{
                marginTop: `-${position}px`, marginLeft: 1
            }}>
                <div className="line-line" style={{
                    height: `${position}px`
                }}></div>
                <div className="break-line">
                </div>
                <div className="line-line" style={{
                    height: (currForm.level && currForm.level.value == "others") ? '100px' : '60px'
                }}></div>
                <div className="break-line">
                </div>
                {
                    form.tournamentFormat == "pool" &&
                    <div className="line-line" style={{
                        height: '55px'
                    }}></div>
                }
                <div className="break-line">
                </div>
            </div>
            <div>
                <Grid mt={-1}>
                    <Grid container xs={12}>
                        <Grid item>
                            <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Level</TCLabel>
                        </Grid>
                        <Grid item>
                            <TCLabel style={{ color: 'red' }}>{joiForm.level}</TCLabel>
                        </Grid>
                    </Grid>
                    <TCSelect disabled={form.disabled || disabled} value={currForm.level} onChange={(e) => {
                        onChange({
                            level: e
                        })
                    }} options={options} />
                </Grid>
                {
                    (currForm.level && currForm.level.value == "others") &&
                    <TCInput styles={{
                        marginTop: 0.5
                    }} value={currForm.customName} placeHolder={'Custom Name'} onChange={(e) => {
                        onChange({ customName: e.currentTarget.value })
                    }} />
                }
                <Grid mt={0.5}>
                    <TCInput type={"number"} disabled={form.disabled} value={currForm.totalPlayer} label={"Total Player"} showAlert={joiForm.totalPlayer}
                        inputProps={{
                            onBlur: (e) => {
                                console.log('here edited in blur', e.currentTarget.value)
                                let value = e.currentTarget.value.replace(/^0+/, "");
                                if (!value) {
                                    onChange({
                                        totalPlayer: value,
                                        numberOfPool: 0,
                                        winnersPerPool: 1
                                    }); return;
                                }
                                let currValue = e.currentTarget.value.replace(/^0+/, "");
                                if (Number(e.currentTarget.value) < 0) {
                                    if (value.includes('doubles')) currValue = 4
                                    else currValue = 2
                                }
                                if (Number(e.currentTarget.value) < currForm.applicant) {
                                    currValue = currForm.applicant
                                }
                                // if (value.includes('doubles') && currValue < 4) { currValue = 4 }
                                if (form.tournamentFormat == "single_elimination") {
                                    if (Number(e.currentTarget.value) > 64) { currValue = 64 }
                                } else {
                                    if (Number(e.currentTarget.value) > 99) { currValue = 99 }
                                }
                                onChange({
                                    totalPlayer: currValue,
                                    numberOfPool: 0,
                                    winnersPerPool: 1
                                })
                            }
                        }}
                        onChange={(e) => {
                            let value = e.currentTarget.value.replace(/^0+/, "");
                            if (!value) {
                                onChange({
                                    totalPlayer: value,
                                    numberOfPool: 0,
                                    winnersPerPool: 1
                                }); return;
                            }
                            let currValue = e.currentTarget.value.replace(/^0+/, "");
                            if (Number(e.currentTarget.value) < 0) {
                                if (value.includes('doubles')) currValue = 4
                                else currValue = 2
                            }
                            if (currForm.applicant > 9 && e.currentTarget.value > 9) {
                                if (Number(e.currentTarget.value) < currForm.applicant) {
                                    currValue = currForm.applicant
                                }
                            }
                            // if (value.includes('doubles') && currValue < 4) { currValue = 4 }
                            if (form.tournamentFormat == "single_elimination") {
                                if (Number(e.currentTarget.value) > 64) { currValue = 64 }
                            } else {
                                if (Number(e.currentTarget.value) > 99) { currValue = 99 }
                            }
                            // onChange({
                            //     totalPlayer: currValue, numberOfPool: 0, winnersPerPool: 0
                            // })
                            onChange({
                                totalPlayer: currValue,
                                numberOfPool: 0,
                                winnersPerPool: 1
                            })
                            // // allow empty or digits only
                            // let raw = e.currentTarget.value.replace(/[^\d]/g, "");
                            // onChange({
                            //     totalPlayer: raw,         // don't clamp here
                            //     numberOfPool: 0,
                            //     winnersPerPool: 1,
                            // });
                        }} />
                </Grid>
                {
                    form.tournamentFormat == "pool" &&
                    <Grid mt={0.5} container columnSpacing={1}>
                        <Grid item xs={6}>
                            <TCInput type={"number"} disabled={form.disabled} value={currForm.numberOfPool} label={"Total Pool"} showAlert={joiForm.numberOfPool}
                                onChange={(e) => {
                                    if (!validation.isNumber(e.currentTarget.value)) { return; }
                                    // tidak boleh ganjil
                                    let value = e.currentTarget.value.replace(/^0+/, "");
                                    if (!value) { onChange({ numberOfPool: value }); return; }
                                    // if ((!currForm.winnersPerPool || currForm.winnersPerPool == 1) && Number(value) <= 4) { value = 4; }
                                    // if ((currForm.winnersPerPool && currForm.winnersPerPool >= 2) && Number(value) <= 2) { value = 2; }
                                    // if (e.currentTarget.value % 2 != 0) return;
                                    let data = currForm
                                    let totalPlayer = 2
                                    if (!data) { totalPlayer = 2 }
                                    else { totalPlayer = data.totalPlayer }
                                    if (Number(value) >= Number(totalPlayer)) {
                                        value = Number(totalPlayer) - 1
                                        if (value % 2 != 0) { value = Number(totalPlayer) }
                                        if (Number(totalPlayer) % 2 != 0) { value = Number(totalPlayer) - 1 }
                                    } else {
                                        if (value % 2 != 0) {
                                            if (value < currForm.numberOfPool) { value = Number(value) - 1 }
                                            else { value = Number(value) + 1 }
                                        }
                                    }
                                    if (currForm.winnersPerPool == 1) {
                                        if (value > 32) { value = 32 }
                                    }
                                    if (currForm.winnersPerPool == 2) {
                                        if (value > 16) { value = 16 }
                                    }
                                    onChange({ numberOfPool: value, winnersPerPool: value == 2 ? 2 : 1 })
                                }} />
                        </Grid>
                        <Grid item xs={6} >
                            <TCInput label={"Winners per Pool"} disabled={form.disabled} type="number" value={currForm.winnersPerPool || 0}
                                // disabled={true}
                                buttonPosition="outside" // or 'inside'
                                onChange={(e) => {
                                    if (!validation.isNumber(e.currentTarget.value)) { return; }
                                    let value = e.currentTarget.value.replace(/^0+/, "");
                                    let totalPlayerPerPool = Math.floor(currForm.totalPlayer / currForm.numberOfPool)
                                    if (!value) {
                                        onChange({ winnersPerPool: value }); return;
                                    }
                                    if (currForm.numberOfPool <= 2) {
                                        onChange({ winnersPerPool: 2 })
                                        return;
                                    }
                                    if (value > totalPlayerPerPool) {
                                        onChange({ winnersPerPool: 2 })
                                        return;
                                    }
                                    // if (value == 1) { if (currForm.numberOfPool == 2) { onChange({ numberOfPool: 4 })} }
                                    if (Number(value) <= 0) { onChange({ winnersPerPool: 1 }); return; }
                                    onChange({ winnersPerPool: value })
                                }} />
                        </Grid>
                    </Grid>
                }
            </div>
        </div>
    )
}

function LogicInputCheck({

}) {
    return
}

export default AddTournament;
